module.exports = __webpack_public_path__ + "media/images/front/sp/for-doctors/bn_keijinkai-6b95f9d05ce88aa9ecaf8deb0d721b89.png";